import { apiRequest } from './client';
import type { WorkItemActualHoursView } from './types';

/**
 * Work-item actual-hours edit endpoint. Two URL shapes for the two work-item kinds:
 *   - Jira-linked: scope = 'jira', id = issueKey
 *   - Standalone PR: scope = 'pr', id = analysisId
 *
 * The {author} segment matches the WorkItemView.author splitter — same author the work
 * item is keyed on in the detail page URL.
 */
export const workItems = {
  setActualHours: (
    organizationId: string,
    scope: 'jira' | 'pr',
    id: string,
    author: string,
    actualHours: number | null,
  ) =>
    apiRequest<WorkItemActualHoursView>(
      `/api/work-items/${scope}/${encodeURIComponent(id)}/${encodeURIComponent(author)}/actual-hours`,
      {
        method: 'PATCH',
        organizationId,
        body: { actualHours },
      },
    ),
};
